import { sortNames } from 'features/Messaging/messaging-helpers'
import { useEffect, useRef, useState } from 'react'

import styles from '../SidebarControls.module.scss'
import { ReactComponent as SortIcon } from '../sort.svg'

const SortDropdown = ({ sortParam, handleSortChange }) => {
  const [open, setOpen] = useState()
  const node = useRef()

  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      return
    }
    setOpen(false)
  }

  const handleOptionClick = val => {
    setOpen(false)
    handleSortChange(val)
  }

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])

  return (
    <>
      <button className={styles.sortButton} onClick={() => setOpen(true)}>
        <SortIcon title="sort results" />
      </button>
      {open && (
        <div ref={node} className={styles.sortDropdown}>
          {Object.keys(sortNames).map(k => (
            <SortOption
              handleClick={handleOptionClick}
              val={k}
              isActive={k === sortParam}
              key={k}
            />
          ))}
        </div>
      )}
    </>
  )
}

const SortOption = ({ handleClick, val, isActive }) => (
  <div
    onClick={() => handleClick(val)}
    className={isActive ? styles.optionActive : styles.option}
  >
    {sortNames[val]}
  </div>
)

export default SortDropdown
